// extracted by mini-css-extract-plugin
export default {"wrapper":"Ym-z","viewport":"Zm-z","container":"_m-z","slide":"an-z"};